import {ensureFlexsliderPlugin} from './sliders';

function getSlidesHeight($, options)
{
    var slidesHeight = $(window).width() / 2.69;

    if ($('.chaletBanner').length) {
        slidesHeight = $(window).width() / 2.59;
    }

    if (options && options.maxSlidesHeight) {
        slidesHeight = Math.min(slidesHeight, options.maxSlidesHeight);
    }

    return slidesHeight;
}

function updateCaptionPosition($, slidesHeight)
{
    if ($('.chaletBanner').length) {
        $('.flexslider .wsflexslider-style3 .caption-text').css('margin-top', parseInt(slidesHeight / 2) + 'px');
    } else {
        $('.flexslider .wsflexslider-style3 .caption-text').css('margin-top', parseInt(slidesHeight / 2 - 50) + 'px');
    }
}

function loadLazySlideImage($, image, slidesHeight)
{
    var $image = $(image);
    var src = $image.attr('data-src');

    if (src) {
        $image.attr('src', src).removeAttr('data-src');
    }

    $image.closest('li').css('display', 'block');

    if ($image.height() > slidesHeight) {
        var marginChange = parseInt(-1 * (($image.height() - slidesHeight) / 2) + 50);

        if ($('.chaletBanner').length) {
            marginChange = parseInt(-1 * (($image.height() - slidesHeight) / 2));
        }

        $image.css('margin-top', marginChange + 'px');
    }

    updateCaptionPosition($, slidesHeight);
}

export function initFlexsliderBanner(selector, options)
{
    if (!window.jQuery) {
        return;
    }

    ensureFlexsliderPlugin();

    var $ = window.jQuery;
    var settings = options || {};
    var flexsliderOptions = Object.assign({}, settings);

    delete flexsliderOptions.maxSlidesHeight;

    $(window).on('load', function () {
        $(selector || '.flexslider').each(function () {
            var $slider = $(this);
            var slideCount = $slider.find('.slides > li').length;

            if (!$.fn.flexslider || slideCount <= 1) {
                $('body').removeClass('loading');
                $('.slide-current-slide').text(slideCount ? 1 : '');
                $('.slide-total-slides').text(slideCount ? ' / ' + slideCount : '');
                return;
            }

            $slider.flexslider(Object.assign({
                animation: 'fade',
                animationLoop: true,
                itemMargin: 0,
                easing: 'swing',
                direction: 'horizontal',
                reverse: false,
                smoothHeight: false,
                startAt: 0,
                slideshow: true,
                slideshowSpeed: 7000,
                animationSpeed: 600,
                initDelay: 0,
                randomize: false,

                pauseOnAction: true,
                pauseOnHover: false,
                useCSS: true,
                touch: true,
                video: false,

                controlNav: false,
                directionNav: true,
                prevText: 'Previous',
                nextText: 'Next',

                keyboard: true,
                multipleKeyboard: false,
                mousewheel: false,
                pausePlay: false,
                pauseText: 'Pause',
                playText: 'Play',

                controlsContainer: '',
                manualControls: '',
                sync: '',
                asNavFor: '',

                itemWidth: 0,
                minItems: 0,
                maxItems: 0,
                move: 0,

                carousel: false,
                start: function (slider) {
                    $('body').removeClass('loading');
                    $('.slide-current-slide').text(slider.currentSlide + 1);
                    $('.slide-total-slides').text(' / ' + slider.count);

                    var slidesHeight = getSlidesHeight($, settings);

                    $(slider).find('img.lazy:eq(0)').each(function () {
                        loadLazySlideImage($, this, slidesHeight);
                    });
                },
                before: function (slider) {
                    $('.slide-current-slide').text(slider.animatingTo + 1);

                    var slidesHeight = getSlidesHeight($, settings);
                    var slides = slider.slides;
                    var index = slider.animatingTo;
                    var current = index;
                    var nextSlide = current + 1;
                    var previousSlide = current - 1;

                    $(slides[index])
                        .parent()
                        .find('img.lazy:eq(' + current + '), img.lazy:eq(' + previousSlide + '), img.lazy:eq(' + nextSlide + ')')
                        .each(function () {
                            loadLazySlideImage($, this, slidesHeight);
                        });
                }
            }, flexsliderOptions));
        });
    });
}
